import React from 'react'
import clsx from 'clsx'
import { Box, Container, Grid } from '@material-ui/core'
import FlipMove from 'react-flip-move'
import PropTypes from 'prop-types'
import EditableHTML from '@v4/components/common/EditableHTML'
import PageMetaData from '@v4/utils/data/PageMetaData'
import EditableContainer from '@v4/components/common/EditableContainer'
import Item from './components/Item'
import { useCategory7 } from './Category.hooks'

const Category7 = props => {
	const [
		{ classes, maxWidth, itemAlign, title, titleConfig, titleEditable, columnsNumber, items, titleKey },
		{ handleTitleClick, handleTitleChange },
	] = useCategory7(props)

	return (
		<div className="category7-root">
			<Container className={clsx(classes.container, 'category7-content')} maxWidth={maxWidth}>
				<EditableContainer
					visible={!!title}
					fieldConfig={titleConfig}
					onAdd={handleTitleChange}
					editable={titleEditable}
					wrapper={({ children }) => (
						<Grid container className={clsx(classes.gridTitleContainer, 'category7-title-container')}>
							<Grid item xs={12} sm={10} md={6}>
								<Box className={clsx(classes.titleWrap, 'category7-title')}>{children}</Box>
							</Grid>
						</Grid>
					)}
				>
					<EditableHTML
						key={titleKey}
						className={clsx(classes.title, 'category7-text-block-title')}
						gutterBottom
						html={title}
						onClick={handleTitleClick}
						editable={titleEditable}
						onChange={handleTitleChange}
					/>
				</EditableContainer>
				<Grid container className={clsx(classes.gridContainer, 'category7-items')} justify="center" spacing={5}>
					<FlipMove duration={300} typeName={null}>
						{_.map(items, (key, index) => (
							<Grid
								className={clsx(classes.item, 'category7-item')}
								key={key}
								item
								lg={12 / columnsNumber}
								md={columnsNumber < 4 ? 12 / columnsNumber : 3}
								sm={columnsNumber < 2 ? 12 : 6}
								xs={12}
							>
								<Item key={key} group="items" itemKey={key} index={index} itemAlign={itemAlign} />
							</Grid>
						))}
					</FlipMove>
				</Grid>
			</Container>
		</div>
	)
}

Category7.propTypes = {
	metaData: PropTypes.shape({
		columns: PropTypes.instanceOf(PageMetaData),
		items: PropTypes.instanceOf(PageMetaData),
		title: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default Category7
